














import { defineComponent } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppRow from '@berlin-front/common/components/elements/AppRow';

import { formatNumber } from '@berlin-front/common/utils';

import { TEXT_COLOR, TEXT_SIZE } from '@berlin-front/common/components/elements/AppText/composable';

export default defineComponent({
  name: 'PaymentMethodInfo',
  components: {
    AppText,
    AppRow,
  },

  props: {
    splitAmount: {
      type: Number,
      required: true,
    },

    splitTimes: {
      type: Number,
      required: true,
    },

    message: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { formatNumber, TEXT_SIZE, TEXT_COLOR };
  },
});
